module.exports = {
      id: "Check_Green-usage",
      viewBox: "0 0 11 10",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/simulator/sprite.svg#Check_Green-usage",
      toString: function () {
        return this.url;
      }
    }